import { useContext } from 'react'

import { ThemeContext } from './themeContext'

/**
 * Read the current theme and brand colour.
 *
 * @returns {{theme: string, setTheme: (theme: string) => void, resolved: 'light'|'dark', brand: string, setBrandPreview: (hex: string|null) => void}}
 * @throws {Error} When called outside `<ThemeProvider>`
 */
export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) throw new Error('useTheme must be used inside <ThemeProvider>')
  return context
}

export default useTheme
